import { ILoadingCellRendererAngularComp } from '@ag-grid-community/angular';
import { ILoadingCellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/loadingCellRenderer';
import { Component } from '@angular/core';

@Component({
    selector: 'app-loading-cell-renderer',
    template: `
        <div class="ag-custom-loading-cell" style="padding-left: 20px">
            <span> {{ params.loadingMessage }} </span>
        </div>
    `,
    standalone: false,
})
export class CustomLoadingCellRenderer implements ILoadingCellRendererAngularComp {
    public params!: ILoadingCellRendererParams & { loadingMessage: string };

    agInit(params: ILoadingCellRendererParams & { loadingMessage: string }): void {
        this.params = params;
    }
}
